class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    if (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll'))
      loadMore();

    colorSwatches();

    // Dispatch custom event for stock status repositioning
    document.dispatchEvent(new CustomEvent('sparklayer:reposition-stock-status'));
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const count = parsedHTML.getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    // Sync .total-products from the fresh server-rendered value in the AJAX response
    const freshTotal = parsedHTML.querySelector('.total-products');
    const liveTotal = document.querySelector('.total-products');
    if (freshTotal && liveTotal) {
      liveTotal.textContent = freshTotal.textContent.trim();
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    console.log('=== FACET RENDER DEBUG ===');
    console.log('Event target:', event?.target);
    console.log('Event filter:', event?.target?.closest('.js-filter'));
    console.log('Source facets found:', facetDetailsElements.length);
    console.log('Facets to render:', facetsToRender.length);

    // Group facets by form to handle them separately
    const desktopSourceFacets = facetsToRender.filter(el => el.closest('form')?.id === 'FacetFiltersForm');
    const mobileSourceFacets = facetsToRender.filter(el => el.closest('form')?.id === 'FacetFiltersFormMobile');

    const desktopTargetFacets = Array.from(document.querySelectorAll('#FacetFiltersForm .js-filter'));
    const mobileTargetFacets = Array.from(document.querySelectorAll('#FacetFiltersFormMobile .js-filter'));

    console.log('Desktop: Source =', desktopSourceFacets.length, 'Target =', desktopTargetFacets.length);
    console.log('Mobile: Source =', mobileSourceFacets.length, 'Target =', mobileTargetFacets.length);

    // Debug mobile facet indexes
    console.log('Mobile source facets:', mobileSourceFacets.map(el => ({
      index: el.dataset.index,
      label: el.querySelector('.mobile-facets__summary')?.textContent?.trim()
    })));
    console.log('Mobile target facets:', mobileTargetFacets.map(el => ({
      index: el.dataset.index,
      label: el.querySelector('.mobile-facets__summary')?.textContent?.trim()
    })));

    // Better approach: Try to match facets by their filter labels, not just position
    desktopSourceFacets.forEach((sourceElement, index) => {
      // Get the filter label from the source facet
      const sourceLabel = sourceElement.querySelector('.facets__summary-title')?.textContent?.trim();

      // Try to find target facet with matching label first
      let targetElement = null;
      if (sourceLabel) {
        targetElement = desktopTargetFacets.find(target => {
          const targetLabel = target.querySelector('.facets__summary-title')?.textContent?.trim();
          return targetLabel === sourceLabel;
        });
      }

      // Fallback to position-based if label matching fails
      if (!targetElement && index < desktopTargetFacets.length) {
        targetElement = desktopTargetFacets[index];
      }

      if (targetElement) {
        const targetIndex = desktopTargetFacets.indexOf(targetElement);
        console.log(`Updating desktop facet "${sourceLabel}" (${sourceElement.dataset.index} -> ${targetElement.dataset.index}) at position ${targetIndex + 1}`);
        targetElement.innerHTML = sourceElement.innerHTML;
      } else {
        console.warn(`No desktop target for source facet "${sourceLabel}" (${sourceElement.dataset.index})`);
      }
    });

    // Track which mobile target facets have been updated
    const updatedMobileTargets = new Set();

    // Same approach for mobile facets
    mobileSourceFacets.forEach((sourceElement, index) => {
      // Skip if source element is invalid
      if (!sourceElement || !sourceElement.dataset || !sourceElement.dataset.index) {
        console.warn('Skipping invalid mobile source facet at index', index);
        return;
      }

      // For mobile, handle sorting separately
      if (sourceElement.dataset.index === 'mobile-sorting' || sourceElement.dataset.index.includes('sorting')) {
        const sortingTarget = mobileTargetFacets.find(target =>
          target.dataset.index && target.dataset.index.includes('sorting')
        );
        if (sortingTarget) {
          console.log('Updating mobile sorting facet');
          sortingTarget.innerHTML = sourceElement.innerHTML;
          updatedMobileTargets.add(sortingTarget);
        }
        return;
      }

      // Get the filter label from the source facet
      const sourceLabel = sourceElement.querySelector('.mobile-facets__summary')?.textContent?.trim();

      // Skip facets without proper labels
      if (!sourceLabel) {
        console.warn(`Skipping mobile facet with no label (${sourceElement.dataset.index})`);
        return;
      }

      let targetElement = null;

      // Strategy 1: Try exact data-index matching first (most reliable)
      if (sourceElement.dataset.index) {
        targetElement = mobileTargetFacets.find(target =>
          target.dataset.index === sourceElement.dataset.index
        );
        if (targetElement) {
          console.log(`Updating mobile facet "${sourceLabel}" by exact index match (${sourceElement.dataset.index})`);
        }
      }

      // Strategy 2: Try label matching if index matching failed
      if (!targetElement && sourceLabel) {
        targetElement = mobileTargetFacets.find(target => {
          const targetLabel = target.querySelector('.mobile-facets__summary')?.textContent?.trim();
          return targetLabel === sourceLabel && target.dataset.index && !target.dataset.index.includes('sorting');
        });
        if (targetElement) {
          console.log(`Updating mobile facet "${sourceLabel}" by label match (${sourceElement.dataset.index} -> ${targetElement.dataset.index})`);
        }
      }

      // Strategy 3: Try numeric pattern matching for mobile-X format
      if (!targetElement && sourceElement.dataset.index) {
        const sourceIndexMatch = sourceElement.dataset.index.match(/mobile-(\d+)/);
        if (sourceIndexMatch) {
          const sourceNumber = sourceIndexMatch[1];
          targetElement = mobileTargetFacets.find(target => {
            return target.dataset.index === `mobile-${sourceNumber}`;
          });
          if (targetElement) {
            console.log(`Updating mobile facet "${sourceLabel}" by numeric pattern (${sourceElement.dataset.index} -> ${targetElement.dataset.index})`);
          }
        }
      }

      if (targetElement) {
        targetElement.innerHTML = sourceElement.innerHTML;
        updatedMobileTargets.add(targetElement);
      } else {
        console.warn(`No mobile target found for source facet "${sourceLabel}" (${sourceElement.dataset.index})`);
      }
    });

    // Hide any mobile target facets that weren't updated (they don't exist in the current filter state)
    mobileTargetFacets.forEach(target => {
      if (!updatedMobileTargets.has(target) && !target.dataset.index.includes('sorting')) {
        console.log(`Hiding unused mobile target facet: ${target.dataset.index}`);
        target.style.display = 'none';
      } else if (target.style.display === 'none') {
        // Show facets that were previously hidden but now have content
        target.style.display = '';
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event?.target) {
      const targetFilter = event.target.closest('.js-filter');
      if (targetFilter) {
        FacetFiltersForm.renderCounts(countsToRender, targetFilter);
      }
    }

    // After DOM updates, browsers don't re-evaluate :hover until the mouse moves.
    // Dispatch a synthetic mousemove at the last known cursor position so the
    // stale hover border on the adjacent filter clears immediately.
    document.dispatchEvent(new MouseEvent('mousemove', {
      bubbles: true,
      cancelable: true,
      clientX: FacetFiltersForm._mouseX,
      clientY: FacetFiltersForm._mouseY
    }));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    if (!source || !target) {
      console.warn('renderCounts: source or target is null');
      return;
    }

    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Track mouse position so we can re-evaluate :hover after DOM updates
FacetFiltersForm._mouseX = 0;
FacetFiltersForm._mouseY = 0;
document.addEventListener('mousemove', (e) => {
  FacetFiltersForm._mouseX = e.clientX;
  FacetFiltersForm._mouseY = e.clientY;
}, { passive: true });

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  fillSlider() {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    inputRangeWrappers.forEach(inputWrapper => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];

      const range = inputRangeTo.max - inputRangeTo.min;
      const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
      const toCurrent = inputRangeTo.value - inputRangeTo.min;
      const minRange = fromCurrent / range * 100;
      const maxRange = toCurrent / range * 100;

      inputWrapper.setAttribute(
        'style',
        `--range-min: ${minRange}%; --range-max: ${maxRange}%`
      );
    })
  }

  controlSlider() {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom = inputNumberWrappers[index].querySelectorAll('.field__input')[0];
      const inputNumberTo = inputNumberWrappers[index].querySelectorAll('.field__input')[1];

      inputRangeFrom.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        }
        else {
          inputNumberFrom.value = from;
        }

        this.fillSlider();
      }

      if (Number(inputRangeTo.value) <= 0) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      inputRangeTo.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        }
        else {
          inputNumberTo.value = from;
          inputRangeTo.value = from;
        }

        if (Number(inputRangeTo.value) <= 0) {
          inputRangeTo.style.zIndex = 2;
        } else {
          inputRangeTo.style.zIndex = 0;
        }

        this.fillSlider();
      }
    })
  }

  controlInput() {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

    inputNumberWrappers.forEach((inputWrapper, index) => {
      const inputsNumber = inputWrapper.querySelectorAll('.field__input');
      const inputNumberFrom = inputsNumber[0];
      const inputNumberTo = inputsNumber[1];
      const inputRangeFrom = inputRangeWrappers[index].querySelectorAll('.field__range')[0];
      const inputRangeTo = inputRangeWrappers[index].querySelectorAll('.field__range')[1];

      inputNumberFrom.oninput = () => {
        const from = parseInt(inputNumberFrom.value, 10);
        const to = parseInt(inputNumberTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        }
        else {
          inputRangeFrom.value = from;
        }

        this.fillSlider();
      }

      inputNumberTo.oninput = () => {
        const from = parseInt(inputNumberFrom.value, 10);
        const to = parseInt(inputNumberTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        }
        else {
          inputNumberTo.value = from;
        }

        this.fillSlider();
      }

    })
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

// Handle active facets display fallback for browsers without :has() support
document.addEventListener('DOMContentLoaded', function () {
  function updateSortWrapperClass() {
    const sortWrapper = document.querySelector('.facets__sort-wrapper');
    if (sortWrapper) {
      const activeFacets = sortWrapper.querySelector('.active-facets-inline facet-remove');
      if (activeFacets) {
        sortWrapper.classList.remove('no-active-facets');
      } else {
        sortWrapper.classList.add('no-active-facets');
      }
    }
  }

  // Initial check
  updateSortWrapperClass();

  // Check after any filter updates
  const observer = new MutationObserver(updateSortWrapperClass);
  const sortWrapper = document.querySelector('.facets__sort-wrapper');
  if (sortWrapper) {
    observer.observe(sortWrapper, { childList: true, subtree: true });
  }
});
